import React from 'react';
import BaseModal from '../../../utils/BaseModal';

interface SystemMessageModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (mfaCode?: string) => void | Promise<void>;
    loading?: boolean;
}

const SystemMessageModal: React.FC<SystemMessageModalProps> = ({
                                                                   open,
                                                                   onClose,
                                                                   onConfirm,
                                                                   loading = false,
                                                               }) => {
    return (
        <BaseModal
            open={open}
            title="Save System Message Configuration"
            onAbort={onClose}
            onSubmit={onConfirm}
            abortText="Cancel"
            submitText="Confirm & Save"
            submitColor="primary"
            loading={loading}
            mfaMode="REQUIRED"
            maxWidth="sm"
        >
            <div className="text-sm text-gray-700 dark:text-gray-300 py-2">
                Are you sure you want to update the global system message? This action will immediately update the banner for all active users.
            </div>
        </BaseModal>
    );
};

export default SystemMessageModal;